import React, { useEffect, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClientXml from "../../utils/HttpClientXml";
import HomeServices from "../../Services/HomeServices";
import "./Pages.css";
import Swal from "sweetalert2";
import { Form, Link, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BackPageBtn from "../BackButton/BackPageBtn";
import { RiDeleteBin2Fill } from "react-icons/ri";

const ManageUser = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const imgURL = "https://api.deshvidesh.ca";

  const [allData, setAllData] = useState();
  const [editId, setEditId] = useState("");
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [fetchAllStaffLoading, setFetchAllStaffLoading] = useState(false);
  const [userIdForAssignmentOfStaff, setUserIdForAssignmentOfStaff] =
    useState("");
  const [staffIdForBeingAssigned, setStaffIdForBeingAssigned] = useState("");
  const [assignStaffLoading, setAssignStaffLoading] = useState(false);

  const initValue = {
    serviceName: "",
    documentation: selectedTypes,
  };
  const [formValue, setFormValue] = useState(initValue);

  const fetchDocumentTypes = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllDocumentTypes();
      console.log("WED62", response.data);
      if (response && response?.status) {
        setDocumentTypes(response.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  const [isEdit, setIsEdit] = useState(true);
  const [editData, setEditData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({ ...prev, [name]: value }));
  };

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("alldasdasdd", formValue);
    // return
    const { title, description } = formValue;
    const isValid = title.trim() !== "" && description.trim() !== "";

    if (isValid) {
      if (formValue?.image1 === "" || formValue?.image2 === "") {
        return toast.error("Please Upload Images");
      } else {
        const res = await HomeServices.addBlog(formValue);
        // console.log("resCat", res)
        if (res && res?.status) {
          toast.success("Blog Added Successfully");
          fetchData();

          // navigate('/manage-category');
          setIsLoading(false);
          console.log("formValue21456", formValue);
        } else {
          toast.error(res?.message || "Something Wrong");
          setIsLoading(false);
        }
      }
    } else {
      toast.error("Please Fill All The Inputs, Including the Image.");
    }
  };

  const viewAssignedServices = (e, item) => {
    e.preventDefault();
    navigate("/assigned-services", { state: { user: item } });
  };

  const viewPayments = (e, item) => {
    e.preventDefault();
    navigate("/manage-payments", { state: { user: item } });
  };

  const columns = [
    { name: "SL No.", selector: "sln", sortable: true, center: true },
    { name: "Customer#", selector: "customerNo", wrap: true, center: true },
    { name: "Name", selector: "name", wrap: true, center: true },
    { name: "Email", selector: "email", wrap: true, center: true },
    { name: "Service", selector: "viewServices", wrap: true, center: true },
    { name: "Payments", selector: "payments", wrap: true, center: true },
    { name: "Staff", selector: "staff", wrap: true, center: true },
    {
      name: "Calender Notes",
      selector: "calender_notes",
      wrap: true,
      center: true,
    },
    { name: "Application Form", selector: "primaryApplicantData", wrap: true },
  ];

  const [allDataWithoutFilter, setAllDataWithoutFilter] = useState([]);
  const fetchData = async () => {
    try {
      // Call your API function
      const response = await HomeServices.getAllUsers();
      console.log("SER99", response);
      if (response && response?.status) {
        console.log("Amit Users", response?.data);
        let arr = response?.data?.reverse()?.map((ele, index) => {
          return {
            sln: index + 1,
            customerNo: ele?.customerNo,
            name: ele?.name,
            email: ele?.email,
            viewServices: (
              <>
                <div>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={(e) => viewAssignedServices(e, ele)}
                  >
                    View/Assign ({ele?.AssignServices?.length})
                  </button>
                </div>
              </>
            ),
            payments: (
              <>
                <div>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={(e) => viewPayments(e, ele)}
                  >
                    View/Send Link
                  </button>
                </div>
              </>
            ),
            staff: (
              <>
                {ele?.assignedStaffName && (
                  <div>
                    {ele?.assignedStaffName}
                    <div style={{ textAlign: "center" }}>
                      <RiDeleteBin2Fill
                        style={{
                          color: "red",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleDeleteAssignedStaff(ele?.AssignStaff[0]?._id);
                        }}
                      />
                    </div>
                  </div>
                )}
                {!ele?.assignedStaffName && (
                  <div>
                    <button
                      disabled={fetchAllStaffLoading}
                      type="button"
                      className="btn btn-info btn-sm"
                      // onClick={(e) => viewAssignedServices(e, ele)}
                      onClick={() => {
                        setUserIdForAssignmentOfStaff(ele?._id);
                        // console.log("Id", ele?._id);
                      }}
                    >
                      {fetchAllStaffLoading ? "Loading..." : "Assign Staff"}
                    </button>
                  </div>
                )}
              </>
            ),
            primaryApplicantData: (
              <>
                {ele?.PrimaryApplicantData?.isFinallySubmittedForm && (
                  <div>
                    <button
                      style={{
                        padding: "3px 5px",
                        borderRadius: "5px",
                        backgroundColor: "#871903",
                        color: "white",
                        height: "40px",
                        fontWeight: "400",
                      }}
                      onClick={() => {
                        navigate("/immigration-form-view", {
                          state: {
                            fullFormData: ele?.PrimaryApplicantData,
                          },
                        });
                      }}
                    >
                      View Application
                    </button>
                  </div>
                )}
              </>
            ),
            calender_notes: (
              <>
                <div>
                  <button
                    style={{
                      padding: "3px 5px",
                      borderRadius: "5px",
                      backgroundColor: "#9c9206",
                      color: "white",
                      height: "40px",
                      fontWeight: "400",
                      border: "none",
                    }}
                    onClick={() => {
                      navigate("/calendar-notes", {
                        state: {
                          user: ele,
                        },
                      });
                    }}
                  >
                    Add / View Reminder
                  </button>
                </div>
              </>
            ),
          };
        });
        setAllData(arr);
        setAllDataWithoutFilter(arr);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  const handleDeleteAssignedStaff = async (id) => {
    try {
      const res = await HomeServices.deleteAssignedStaff(id);
      if (res?.status) {
        toast.success(res?.message);
        fetchData();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllStuffs = async () => {
    try {
      setFetchAllStaffLoading(true);
      // Call your API function
      const response = await HomeServices.getAllStaffs();
      if (response && response?.status) {
        // console.log("Amit ", response?.data);
        setStaffs(response?.data);
        setFetchAllStaffLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Staffs :", error);
      setFetchAllStaffLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentTypes();
    fetchData();
    fetchAllStuffs();
  }, []);

  const handleDelete = async (id) => {
    console.log("deleteblogid", id);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      console.log("result", result);
      if (result?.isConfirmed) {
        HomeServices.deleteService(id)
          .then((res) => {
            if (res && res.status) {
              toast.success("Deleted Successfully");
              fetchData();
            } else {
              toast.error(res?.message);
            }
          })
          .catch((err) => {
            console.error("Error deleting document:", err);
          });
      } else {
        console.log("Deletion canceled");
      }
    });
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedTypes((prev) =>
      checked ? [...prev, value] : prev.filter((type) => type !== value),
    );
  };

  useEffect(() => {
    setFormValue({ ...formValue, documentation: selectedTypes });
  }, [selectedTypes]);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const filtered = allDataWithoutFilter.filter(
      (item) =>
        item.name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.email.toLowerCase().includes(searchText.toLowerCase()),
    );

    setAllData(filtered);
  }, [searchText]);

  const handleAssignStaff = async () => {
    if (!staffIdForBeingAssigned) return toast.error("Please Select a Stuff");

    try {
      setAssignStaffLoading(true);
      const response = await HomeServices.assignStaff({
        staffId: staffIdForBeingAssigned,
        userId: userIdForAssignmentOfStaff,
      });

      if (response.status) {
        toast.success(response.message);

        setStaffIdForBeingAssigned("");
        setUserIdForAssignmentOfStaff("");
        fetchData();
        setAssignStaffLoading(false);
      } else {
        toast.error(response.message);
        setStaffIdForBeingAssigned("");
        setAssignStaffLoading(false);
      }
    } catch (error) {
      console.error("Error Creating Staff:", error);
      setAssignStaffLoading(false);
    }
  };

  return (
    <>
      {userIdForAssignmentOfStaff && (
        <div className="d-flex justify-content-end">
          <div className="form-header">
            <section className="piechartsBox_area">
              <h1
                style={{
                  color: "#ff9c00",
                  fontSize: "25px",
                  fontWeight: "600",
                  marginBottom: "25px",
                }}
              >
                Staffs
              </h1>
              <div>
                {staffs?.map((e, i) => {
                  return (
                    <div key={i}>
                      <div
                        style={{
                          display: "flex",
                          gap: "15px",
                          alignItems: "center",
                        }}
                      >
                        <input
                          style={{ cursor: "pointer" }}
                          name="staff"
                          type="radio"
                          value={e?._id}
                          onChange={() => {
                            setStaffIdForBeingAssigned(e?._id);
                          }}
                          checked={staffIdForBeingAssigned === e._id}
                        />
                        <label style={{ paddingTop: "5px" }}>
                          {e?.name + " " + `( Phone No : ${e?.phoneNo} )`}
                        </label>
                      </div>
                    </div>
                  );
                })}
                <div
                  style={{ marginTop: "20px", display: "flex", gap: "15px" }}
                >
                  <button
                    disabled={assignStaffLoading}
                    className="btn btn-primary"
                    onClick={() => {
                      handleAssignStaff();
                    }}
                  >
                    {assignStaffLoading ? "Assigning..." : "Assign"}
                  </button>
                  <button
                    disabled={assignStaffLoading}
                    className="btn btn-danger"
                    onClick={() => {
                      setUserIdForAssignmentOfStaff("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
      {!userIdForAssignmentOfStaff && (
        <>
          <CustomLoader loading={isLoading} />

          {allData?.length > 0 && (
            <>
              <div className="d-flex justify-content-end">
                <div className="form-header">
                  <section className="piechartsBox_area">
                    <div>
                      {/* <BackPageBtn backLink="/view-user-appointment" /> */}
                      <div className="dateListDiv">
                        <h1
                          style={{
                            color: "#ff9c00",
                            fontSize: "25px",
                            fontWeight: "600",
                            marginBottom: "10px",
                          }}
                        >
                          View All Registered Users
                        </h1>

                        <div className="tabRngeDivmain">
                          <div className="strtdivmain">
                            {/* <p className="strttxt">User Email</p> */}
                            <input
                              type="email"
                              name="filterEmail"
                              placeholder="Enter user name/email"
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                          </div>
                          {/* <span>-</span> */}
                          {/* <div className="strtdivmain">
                                      <p className="strttxt">End Date</p>
                                      <input
                                        type="date"
                                        name="endDate"
                                        value={endDate}
                                        onChange={handleEndDateChange}
                                      />
                                    </div> */}
                          {/* <button
                          onClick={filterDataByDateRange}
                          className="Search_icon btn btn-primary"
                          type="button"
                        >
                          Search
                        </button> */}
                        </div>
                      </div>
                    </div>

                    <hr />
                    <DataTable columns={columns} data={allData} pagination />
                  </section>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default ManageUser;
